import styled from 'styled-components';

const MainContainer = styled.div<{ useNewDesign?: boolean }>`
  flex-grow: 1;
  ${({ useNewDesign }) => (useNewDesign ? '> * {margin-bottom: 8px;}' : '')}
`;

export default MainContainer;
